import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-header-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "search-title" }
const _hoisted_6 = {
  class: "search-tags",
  id: "tag_name"
}
const _hoisted_7 = ["id", "checked", "onChange"]
const _hoisted_8 = ["for", "onClick"]
const _hoisted_9 = { class: "search-title" }
const _hoisted_10 = { class: "search-diseases" }
const _hoisted_11 = ["id"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "disease-items" }
const _hoisted_14 = ["id", "onChange", "checked"]
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = { class: "modal-footer-buttons" }
const _hoisted_18 = ["disabled"]

import { onMounted, ref, reactive } from "vue";
import { Tags } from "@/models/tags/tags";
import { Diseases } from "@/models/diseases/diseases";
import { useRouter } from "vue-router";
import { processend, processing } from "@/utils/view";
import ErrorDialog from "@/views/base/CommonMessage.vue";

// ---- interface ----------------------------------------------
interface ArticleQueryCond {
  tagIds?: number[];
  diseaseCodes?: string[];
  posterIds?: number[];
}
interface Disease {
  diseaseCode: string;
  diseaseName: string;
}

interface GroupDiseases {
  group?: string;
  diseases?: Disease[];
}
// ---- Constant ----------------------------------------------
const componentId = "generalpurpose06-01-modal";

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalSearch',
  emits: ["ok", "cancel"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const listTag = ref<{ tagId: number; tagName: string }[]>([]);
const listDisease = ref<GroupDiseases[]>([]);
const diseaseSelected = ref<string[]>([]);
const tagSelected = ref<number[]>([]);
// eslint-disable-next-line no-undef
const emit = __emit;

// セッションエラーチェック
let sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});
// ---- Function ----------------------------------------------
// タグ取得
const fetchTags = async () => {
  const tags = new Tags();
  // listTag.value
  const [_model, response, err] = await tags.getAllTags();
  if (err) {
    if (err) {
      listTag.value = [];
      // セッションエラー
      const status = err.error?.response?.status;
      if (status === 408) {
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        sessionErr.value = true;
        errorDialog.open(decodedMessage);
      }
      return;
    }
  }
  listTag.value = response.data.result;
};

//疾患取得
const fetchDiseases = async () => {
  const disease = new Diseases();
  const [_model, response, err] = await disease.getAllDiseases();
  if (err) {
    listDisease.value = [];
  }
  listDisease.value = response.data.result;
};

// トグル疾患
function toggleDiseaseCode(code: string) {
  const index = diseaseSelected.value.indexOf(code);
  if (index === -1) {
    diseaseSelected.value.push(code); // empty -> add
  } else {
    diseaseSelected.value.splice(index, 1); //exist -> remove
  }
}
// トグルタグ
function toggleTag(tagId: number) {
  const index = tagSelected.value.indexOf(tagId);
  if (index === -1) {
    tagSelected.value.push(tagId);
  } else {
    tagSelected.value.splice(index, 1);
  }
}

// 記事一覧ページへ遷移
const goToArticlePage = () => {
  const cond: ArticleQueryCond = {};
  cond.diseaseCodes = diseaseSelected.value;
  cond.tagIds = tagSelected.value;
  emit("cancel");
  router.push({
    name: "article/search",
    query: {
      cond: encodeURIComponent(JSON.stringify(cond)),
    },
  });
};
// ---- Vue lifeCycle -----------------------------------------
onMounted(async () => {
  await fetchTags();
  await fetchDiseases();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("article_modal_title")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("img", { src: "/server/necs/images/tag-icon.png" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_modal_search_title")), 1)
          ]),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listTag.value, (tag, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "tag-item",
                key: tag.tagId
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  id: `tag_name${index}`,
                  checked: tagSelected.value.includes(tag.tagId),
                  onChange: ($event: any) => (toggleTag(tag.tagId))
                }, null, 40, _hoisted_7),
                _createElementVNode("label", {
                  for: `tag_name${index}`,
                  onClick: _withModifiers(($event: any) => (toggleTag(tag.tagId)), ["prevent"])
                }, _toDisplayString(tag.tagName), 9, _hoisted_8)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/server/necs/images/stethoscope_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("article_modal_search_title_list")), 1)
          ]),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listDisease.value, (groupItem, groupIndex) => {
              return (_openBlock(), _createElementBlock("li", {
                key: groupIndex,
                class: "disease-japaneseoder"
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "japaneseoder-select",
                  id: `japaneseoder${groupIndex}`
                }, null, 8, _hoisted_11),
                _createElementVNode("label", {
                  class: "japaneseoder-item",
                  for: `japaneseoder${groupIndex}`
                }, [
                  _createElementVNode("span", null, _toDisplayString(groupItem.group) + _toDisplayString(_ctx.$t("article_modal_search_line")), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("img", { src: "/server/necs/images/open_24dp_FILL0_wght600_GRAD0_opsz24.png" }, null, -1))
                ], 8, _hoisted_12),
                _createElementVNode("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupItem.diseases, (disease, diseaseIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: diseaseIndex,
                      class: "disease-item"
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        id: `disease_name_${groupIndex}_${diseaseIndex}`,
                        onChange: ($event: any) => (toggleDiseaseCode(disease.diseaseCode)),
                        checked: diseaseSelected.value.includes(disease.diseaseCode)
                      }, null, 40, _hoisted_14),
                      _createElementVNode("label", {
                        for: `disease_name_${groupIndex}_${diseaseIndex}`
                      }, _toDisplayString(disease.diseaseName), 9, _hoisted_15)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              type: "button",
              class: "modal-cansel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
            }, _toDisplayString(_ctx.$t("article_modal_cancel_button")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "modal-search",
              disabled: diseaseSelected.value.length === 0 && tagSelected.value.length === 0,
              onClick: goToArticlePage
            }, _toDisplayString(_ctx.$t("article_modal_search_button")), 9, _hoisted_18)
          ])
        ])
      ])
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})